import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ExperienceBuilderApp } from "@/components/experience-builder/ExperienceBuilderApp";
import { trackEvent } from "@/lib/client-telemetry";
import { ExperienceTour } from "@/components/ProductTour";

export const Route = createFileRoute("/app/experience")({
  component: ExperiencePage,
});

function ExperiencePage() {
  useEffect(() => { trackEvent("experience.builder_open"); }, []);
  return (
    <>
      <ExperienceTour />
      <ExperienceBuilderApp />
    </>
  );
}
